/** CSS inlined nel DOM di stampa: Firefox in anteprima spesso non carica i fogli esterni. */
export const DASHBOARD_PRINT_CRITICAL_CSS = `
.mtska-dashboard-print-document {
    width: 100%;
    max-width: 277mm;
    margin: 0 auto;
    box-sizing: border-box;
    color: #111;
    background: #fff;
}

.dashboard-menu-itemgroup-pie.report-itemrow {
    display: flex !important;
    flex-direction: row !important;
    flex-wrap: nowrap !important;
    width: 100% !important;
    max-width: 100% !important;
    gap: 10px;
    box-sizing: border-box;
    margin-bottom: 15px;
}

.dashboard-menu-itemgroup-pie.report-itemrow > * {
    flex: 1 1 0 !important;
    min-width: 0 !important;
    max-width: none !important;
    width: auto !important;
    box-sizing: border-box;
}

.mtska-chart-pie--print {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
}

.mtska-chart-pie--print .mtska-chart-pie-body,
.mtska-chart-pie--print .chartwrapper {
    width: 100% !important;
    max-width: 100% !important;
    min-width: 0 !important;
    box-sizing: border-box !important;
    overflow: hidden !important;
}

.mtska-chart-pie--print .chartwrapper > div,
.mtska-chart-pie--print .apexcharts-canvas,
.mtska-chart-pie--print svg.apexcharts-svg {
    max-width: 100% !important;
}

.mtska-pie-legend-bottom {
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    justify-content: flex-start;
    column-gap: 12px;
    row-gap: 4px;
    overflow: hidden;
    box-sizing: border-box;
}

.mtska-pie-legend-marker {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 2px;
    flex-shrink: 0;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}

.mtska-pie-legend-item {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    border: 0;
    background: none;
    padding: 0;
    margin: 0;
    font-size: 11px;
    line-height: 1.35;
    text-align: left;
}

.mtska-dashboard-print-cover {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 24px;
    min-height: 100vh;
    padding: 48px 24px 64px;
    text-align: center;
    color: #111 !important;
    background: #fff !important;
    break-after: page;
    page-break-after: always;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}

.mtska-dashboard-print-cover .logo {
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
}

.mtska-dashboard-print-cover .logo svg,
.mtska-dashboard-print-cover .logo img {
    height: 60px;
    width: auto;
    max-width: 100%;
}

.mtska-dashboard-print-cover-brand,
.mtska-dashboard-print-cover-title,
.mtska-dashboard-print-cover-date {
    color: #111;
}

.mtska-dashboard-print-cover-brand {
    margin: 0;
    font-size: 60px;
    line-height: 1.1;
    font-weight: 700;
}

.mtska-dashboard-print-cover-title {
    margin: 0;
    font-size: 100px;
    line-height: 1.05;
    font-weight: 700;
    max-width: 100%;
    word-break: break-word;
}

.mtska-dashboard-print-cover-date {
    margin: 200px 0 0;
    font-size: 24px;
    line-height: 1.1;
    font-weight: 500;
}

@media print {
    body.mtska-dashboard-report-printing {
        visibility: visible !important;
        background: #fff !important;
    }

    body.mtska-dashboard-report-printing #root {
        display: none !important;
    }

    body.mtska-dashboard-report-printing > *:not(.MuiModal-root) {
        display: none !important;
    }

    body.mtska-dashboard-report-printing .mtska-dashboard-print-cover {
        min-height: 100vh;
        background: #fff !important;
    }

    .mtska-chart-table--print .mtska-chart-table-data,
    .mtska-chart-table--print .MuiDataGrid-root {
        min-height: unset !important;
        height: auto !important;
    }

    .mtska-chart-table--print .MuiDataGrid-footerContainer {
        display: none !important;
    }

    body.mtska-dashboard-report-printing .mtska-no-print,
    body.mtska-dashboard-report-printing .MuiModal-backdrop,
    body.mtska-dashboard-report-printing .mtska-dashboard-print-modal-chrome {
        display: none !important;
    }
}
`;
